var exports = {
  "zq": "marketplace-list-grid-one__RSYdue",
  "ws": "marketplace-logo-wrapper__GKzgfv",
  "eh": "marketplace-logo__verified-icon-wrapper__dqF8gV",
  "pd": "marketplace-banner-container__az_UBt",
  "xi": "marketplace-version-icon__2Vsfg3",
  "_P": "copyable-code-snippet__bX5exW",
  "$Y": "starred-button-icon__5-MPpO",
  "Z4": "marketplace-cta-buttons-container__Uzmz-e",
  "Ix": "OverviewHeading__2l2eZR",
  "ve": "ResponsiveHeaderControl__DivvGI",
  "Jp": "ResponsiveVisibility__KHH0s4",
  "i1": "marketplace-content-container__8Uw67v",
  "z7": "marketplace-content-container--less-padding__scb9Pe",
  "Ho": "marketplace-content-container--no-padding__gMjyup",
  "z1": "marketplace-content-container__content__mlIFdP",
  "e2": "ButtonGroup__clJG-C",
  "vX": "marketplace-sidebar__pane__9h8nLj",
  "A": "marketplace-sidebar__content-wrapper__gowEPe",
};

module.exports = exports;
